module.exports = __webpack_public_path__ + "img/performance-work-icon4.bf17cba4.png";